// extracted by mini-css-extract-plugin
export default {"subscriptionTable":"xHuKiCBseNh62Vk4Ly5d"};